import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Youtube from "../../pics/YouTube Logo 1.png";
import Twitch from "../../pics/Twitch Logo V2 1.png";
import CustomSwitch from "../../components/custom-ui/CustomSwitch";
import { Link } from "react-router-dom";
import OnboardingCompleteModal from "../../components/Dashcomponents/OnboardingCompleteModal";
import { setYouTubeConnection } from "../../State/authSlicer";
import { setTwitchConnection } from "../../State/authSlicer";
import { useDispatch } from "react-redux";
import apisecured from "../../api/apisecured";
import { toast } from "react-toastify";
import API from "../../api/api";

function ChatBotSetting() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userlogin = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const success = searchParams.get("success");
  const [activePlatform, setActivePlatform] = useState("youtube");
  const { youtubeEmail, isYouTubeConnected } = useSelector(
    (state) => state.auth
  );
  const [localYouTubeConnected, setLocalYouTubeConnected] =
    useState(isYouTubeConnected);
  const [localYouTubeEmail, setLocalYouTubeEmail] = useState(youtubeEmail);

  const { twitchEmail, isTwitchConnected } = useSelector((state) => state.auth);
  const [localTwitchConnected, setLocalTwitchConnected] =
    useState(isTwitchConnected);
  const [localTwitchEmail, setLocalTwitchEmail] = useState(twitchEmail);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [receiveAllTips, setReceiveAllTips] = useState(true);
  const [receiveGoalFunded, setReceiveGoalFunded] = useState(true);
  const [receiveGeneralTips, setReceiveGeneralTips] = useState(false);
  const [loadingSettings, setLoadingSettings] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchYouTubeStatus = async () => {
      if (!userlogin.uid) return;

      try {
        const response = await apisecured.get(`account/youtube/status`);

        const data = response.data;

        setLocalYouTubeConnected(data.connected);
        setLocalYouTubeEmail(data.email || "");

        dispatch(
          setYouTubeConnection({
            connected: data.connected,
            email: data.email || "",
          })
        );
      } catch (err) {
        console.error("Error fetching YouTube status", err);
      }
    };
    if (!isYouTubeConnected || !youtubeEmail) {
      fetchYouTubeStatus();
    } else {
      // Already present, just mirror to local state
      setLocalYouTubeConnected(isYouTubeConnected);
      setLocalYouTubeEmail(youtubeEmail);
    }
  }, [userlogin.uid]);
  useEffect(() => {
    const fetchTwitchStatus = async () => {
      if (!userlogin.uid) return;

      try {
        const response = await apisecured.get(`account/twitch/status`);
        const data = response.data;

        setLocalTwitchConnected(data.connected);
        setLocalTwitchEmail(data.email || "");

        dispatch(
          setTwitchConnection({
            // Create this action in your authSlicer
            connected: data.connected,
            email: data.email || "",
          })
        );
      } catch (err) {
        console.error("Error fetching Twitch status", err);
      }
    };

    if (!isTwitchConnected || !twitchEmail) {
      fetchTwitchStatus();
    } else {
      setLocalTwitchConnected(isTwitchConnected);
      setLocalTwitchEmail(twitchEmail);
    }
  }, [userlogin.uid]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.get("success") === "true") {
      setShowSuccessModal(true);

      // Remove "success" from the URL after setting the modal
      searchParams.delete("success"); // FIXED: Ensure correct param is removed

      navigate(`${location.pathname}?${searchParams.toString()}`, {
        replace: true, // Prevents adding an extra history entry
      });
    }
  }, []);
  useEffect(() => {
    if (!userlogin.uid) return;

    const fetchSettings = async () => {
      setLoadingSettings(true);
      try {
        const res = await apisecured.get(`/account/get/chatbotsettings`, {
          params: { platform: activePlatform },
        });
        const data = res.data;

        setReceiveAllTips(data.receiveAllTips);
        setReceiveGoalFunded(data.receiveGoalFunded);
        setReceiveGeneralTips(data.receiveGeneralTips);
      } catch (error) {
        console.error("Failed to fetch chatbot settings", error);
      } finally {
        setLoadingSettings(false);
      }
    };

    fetchSettings();
  }, [activePlatform, userlogin.uid]);
  const handleCloseModal = () => {
    setShowSuccessModal(false);

    // Use URLSearchParams to remove 'success'
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("success"); // Remove the success param

    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true, // Prevents adding history entry
    });
  };
  const handleSaveChanges = async () => {
    setSaving(true);
    try {
      await apisecured.post("/account/settings/chatbot", {
        platform: activePlatform,
        receiveAllTips,
        receiveGoalFunded,
        receiveGeneralTips,
      });
      toast.success("Settings saved successfully!");
    } catch (error) {
      const errMsg =
        error?.response?.data?.error || "An unknown error occurred.";
      toast.error(`Failed to save settings: ${errMsg}`);
    } finally {
      setSaving(false);
    }
  };
  const handleYouTubeDisconnect = async () => {
    try {
      const res = await apisecured.post("/account/youtube/disconnect");
      if (res.data.success) {
        toast.success("YouTube disconnected successfully!");
        setLocalYouTubeConnected(false);
        setLocalYouTubeEmail("");
        dispatch(setYouTubeConnection({ connected: false, email: "" }));
      }
    } catch (err) {
      toast.error("Failed to disconnect YouTube");
      console.error("Disconnect error", err);
    }
  };
  const handleTwitchDisconnect = async () => {
    try {
      const res = await apisecured.post("/account/twitch/disconnect");
      if (res.data.success) {
        toast.success("Twitch disconnected successfully!");
        setLocalTwitchConnected(false);
        setLocalTwitchEmail("");
        dispatch(setTwitchConnection({ connected: false, email: "" }));
      }
    } catch (err) {
      toast.error("Failed to disconnect Twitch");
      console.error("Twitch disconnect error", err);
    }
  };

  return (
    <>
      <OnboardingCompleteModal
        open={showSuccessModal}
        onClose={handleCloseModal}
        onModalClose={handleCloseModal}
      />
      {/* Header and platform connect section */}
      <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
        <h2
          className="CustomCardPara  !font-bold !text-left "
          style={{ fontFamily: "Gilroy", fontWeight: "700" }}
        >
          Chatbot
        </h2>

        <h2 className="CustomSignUpLabel !font-medium !ml-0 mt-2">
          Connect your accounts to automatically allow SPONSA’s chatbot to post
          in live chat whenever you receive a tip or a goal is completed!
        </h2>
        <h2 className="CustomSignUpLabel !font-medium !ml-0 mt-6">
          Note: You must add SPONSA Bot as a mod on your channel for this
          integration to work.
        </h2>

        <div className="rounded-xl  bg-[#030021]  ">
          <div className="rounded-xl  bg-[#35334D99] space-y-6 p-6 mt-4 ">
            {/* YouTube Connection */}
            <div className="flex items-center gap-3 text-white">
              <CustomSwitch
                isActive={localYouTubeConnected}
                onClick={() => {
                  if (localYouTubeConnected) {
                    handleYouTubeDisconnect();
                  } else {
                    window.location.href = `${API}account/youtube/connect`;
                    // window.location.href = `https://localhost:44375/v1/account/youtube/connect`;
                  }
                }}
              />
              <div className="flex items-center gap-3">
                <img
                  src={Youtube}
                  alt="YouTube"
                  className="w-[30px] min-w-[30px] h-[30px]"
                />
                <div>
                  <p
                    className="text-white font-bold"
                    style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                  >
                    YouTube
                  </p>
                  {localYouTubeConnected ? (
                    <p className="text-gray-300 text-sm font-medium">
                      Connected with{" "}
                      <span className="font-bold LinkUnderline">
                        {localYouTubeEmail}
                      </span>
                    </p>
                  ) : (
                    <p className="text-gray-300 text-sm font-medium">
                      Not connected —{" "}
                      <span
                        className="underline text-[#00FF8F] cursor-pointer"
                        onClick={() =>
                          (window.location.href = `${API}account/youtube/connect`)
                        }
                      >
                        Connect
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Twitch Connection */}
            <div className="flex items-center gap-3 text-white  ">
              <CustomSwitch
                isActive={localTwitchConnected}
                onClick={() => {
                  if (localTwitchConnected) {
                    handleTwitchDisconnect();
                  } else {
                    window.location.href = `${API}account/twitch/connect`;
                    // window.location.href = `https://localhost:44375/v1/account/twitch/connect`;
                  }
                }}
              />
              <div className="flex items-center gap-3   ">
                <img
                  src={Twitch}
                  alt=""
                  className=" w-[30px] min-w-[30px] h-[30px] "
                />
                <div>
                  <p
                    className="text-white font-bold"
                    style={{ fontFamily: "Gilroy", fontWeight: "700" }}
                  >
                    Twitch
                  </p>
                  {localTwitchConnected ? (
                    <p className="text-gray-300 text-sm font-medium">
                      Connected with{" "}
                      <span className="font-bold LinkUnderline">
                        {localTwitchEmail}
                      </span>
                    </p>
                  ) : (
                    <p className="text-gray-300 text-sm font-medium">
                      Not connected —{" "}
                      <span
                        className="underline text-[#00FF8F] cursor-pointer"
                        onClick={() =>
                          (window.location.href = `${API}account/twitch/connect`)
                        }
                      >
                        Connect
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Platform pills */}
      <div className="flex items-center justify-center gap-2 mt-4">
        <button
          onClick={() => setActivePlatform("youtube")}
          className={`font-bold text-[15px] leading-[18.57px] tracking-[0%] block CustomButtonAnim rounded-[25px] px-[2.6rem] py-[0.5rem] HoverDarker ${
            activePlatform === "youtube"
              ? "bg-[#00FF8F] text-[#030021]"
              : "bg-transparent border border-white text-white"
          }`}
        >
          YouTube
        </button>
        <button
          onClick={() => setActivePlatform("twitch")}
          className={`font-bold text-[15px] leading-[18.57px] tracking-[0%] block CustomButtonAnim rounded-[25px] px-[2.6rem] py-[0.5rem] HoverDarker ${
            activePlatform === "twitch"
              ? "bg-[#00FF8F] text-[#030021]"
              : "bg-transparent border border-white text-white"
          }`}
        >
          Twitch
        </button>
      </div>

      {/* YouTube Customization */}
      {activePlatform === "youtube" && (
        <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
          <h2
            className="CustomCardPara  !font-bold !text-left "
            style={{ fontFamily: "Gilroy", fontWeight: "700" }}
          >
            SPONSA Chatbot Customisation
          </h2>

          <h2 className="CustomSignUpLabel !font-semibold !ml-0 mt-3">
            Customise your SPONSA Chatbot for YouTube here!
            <span className="block !font-[400] italic ">
              Available variables: {`{goal}, {user}, {amount}, {goal URL}`}
            </span>
          </h2>

          {/* Tip Section */}
          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveAllTips}
                  onClick={() => setReceiveAllTips((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">Tips (Towards Goals)</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever you receive a tip
                    towards a goal.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{user} just tipped {amount} towards {goal} on SPONSA! Thank you! {goal URL}`}
            </div>
          </div>

          {/* Fully Funded */}
          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveGoalFunded}
                  onClick={() => setReceiveGoalFunded((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">Fully Funded Goals</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever a goal is fully
                    funded.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{goal} was just fully funded on SPONSA! Thank you! {goal URL}`}
            </div>
          </div>

          {/* General Tips */}
          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveGeneralTips}
                  onClick={() => setReceiveGeneralTips((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">General Tips</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever you receive a
                    General Tip.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{user} just tipped {amount} on SPONSA! Thank you! https://sponsa.app/${userlogin.sponsaUserName} #SPONSA`}
            </div>
          </div>

          <div className="flex justify-center">
            <button
              disabled={saving || loadingSettings}
              onClick={handleSaveChanges}
              className="mx-auto mt-6 font-bold text-[15px] CustomButtonAnim text-[#030021] bg-[#00FF8F] rounded-[25px] px-[2rem] py-[0.5rem] HoverDarker"
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      )}

      {/* Twitch Customization */}
      {activePlatform === "twitch" && (
        <div className="bg-[#35334D] py-8 md:px-10 sm:px-6 px-4 relative ">
          <h2
            className="CustomCardPara  !font-bold !text-left "
            style={{ fontFamily: "Gilroy", fontWeight: "700" }}
          >
            SPONSA Chatbot Customisation
          </h2>

          <h2 className="CustomSignUpLabel !font-semibold !ml-0 mt-3">
            Customise your SPONSA Chatbot for Twitch here!
            <span className="block !font-[400] italic ">
              Available variables: {`{goal}, {user}, {amount}, {goal URL}`}
            </span>
          </h2>

          {/* Duplicate same structure as YouTube - editable later */}
          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveAllTips}
                  onClick={() => setReceiveAllTips((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">Tips (Towards Goals)</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever you receive a tip
                    towards a goal.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{user} just tipped {amount} towards {goal} on SPONSA! Thank you! {goal URL}`}
            </div>
          </div>

          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveGoalFunded}
                  onClick={() => setReceiveGoalFunded((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">Fully Funded Goals</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever a goal is fully
                    funded.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{goal} was just fully funded on SPONSA! Thank you! {goal URL}`}
            </div>
          </div>

          <div className="rounded-xl bg-[#030021] mt-4">
            <div className="bg-[#35334D99] space-y-6 p-6">
              <div className="flex items-center gap-3 text-white">
                <CustomSwitch
                  isActive={receiveGeneralTips}
                  onClick={() => setReceiveGeneralTips((prev) => !prev)}
                />
                <div>
                  <p className="text-white font-bold">General Tips</p>
                  <p className="text-gray-300 text-sm font-medium">
                    Automatically post to live chat whenever you receive a
                    General Tip.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 text-[15px]" style={{ color: "#fff" }}>
              {`{user} just tipped {amount} on SPONSA! Thank you! https://sponsa.app/${userlogin.sponsaUserName} #SPONSA`}
            </div>
          </div>

          <div className="flex justify-center">
            <button
              disabled={saving || loadingSettings}
              onClick={handleSaveChanges}
              className="mx-auto mt-6 font-bold text-[15px] CustomButtonAnim text-[#030021] bg-[#00FF8F] rounded-[25px] px-[2rem] py-[0.5rem] HoverDarker"
            >
              {saving ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ChatBotSetting;
